<template>
  <div class="timeline-item mb-1">
    <div class="timeline-line"></div>
    
    <div class="timeline-icon">
      <span>
        {{ historic.date ? new Date(historic.date).getDate() : new Date().getDate() }}
        {{ historic.date ? $t(getMonthName(new Date(historic.date).getMonth())).substring(0,3) : $t(getMonthName(new Date().getMonth())).substring(0,3) }}
      </span> 
      <span>{{  historic.date ? new Date(historic.date).getFullYear() : new Date().getFullYear() }}</span>
    </div>

    <div class="timeline-content me-2">
      <Card class="card shadow p-0">
        <template #cardBody>
          <p class="text-warning fs-3"><strong>{{historic.user?.firstname + ' ' + historic.user?.lastname}}</strong> <span class="text-muted">{{format(historic.date)}}</span> </p>
          <div>
            <p class="fs-4" v-html="historic.action[locale]"></p>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import Card from "@/components/Card";
import {formatDistance} from "date-fns";
import {fr} from "date-fns/locale";
import {useLocales} from "@/composables/locales";

const props = defineProps({
  historic: { type: Object, default: {} },
});

const {locale} = useLocales()

const nowDate = ref(new Date())

function format(date){
  return formatDistance(new Date(date), nowDate.value, { locale: fr})
}

function getMonthName(monthNumber) {
  const monthNames = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
  ];
  return monthNames[monthNumber];
}
</script>

<style scoped>
.timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
}

.timeline-line {
  position: absolute;
  left: 25px;
  top: 50px;
  bottom: 0;
  border-left: 1px dashed #CCCFD3;
}

.timeline-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  text-align: center;
  font-weight: bold;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #CCCFD3;
  font-size: 8px !important;
}

.timeline-content {
  width: 100%;
  margin-left: 10px;
  margin-top: 50px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 5px;
  background-color: #0072CE33;
  border: 1px solid #0072CE33;
}
</style>
